import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import Dialog from 'libraries/Dialog';
import CircularProgress from '@mui/material/CircularProgress';
import { withStyles } from '@mui/styles';
import KoalaIcon from 'img/koala.svg';
import ReactHtmlParser from 'react-html-parser';
import clsx from 'clsx';
import { loadCandidateMessages } from 'requests/ChatbotRequests';
import BotMessageIcon from './botMessageIcon.svg';
import CandidateMessageIcon from './candidateMessageIcon.svg';


const styles = theme => ({
    name: {
        marginLeft: 22,
        color: theme.palette.grey[600],
        fontSize: 14,
        marginBottom: 8
    },
    message: {
        padding: '18px 26px',
        borderRadius: 16,
        fontSize: 14,
        position: 'relative'
    },
    botMessage: {
        backgroundColor: theme.palette.grey[200],
        '& img': {
            position: 'absolute',
            bottom: -1,
            left: -12
        }
    },
    candidateMessage: {
        backgroundColor: theme.palette.blue[700],
        color: 'white',
        '& img': {
            position: 'absolute',
            bottom: 0,
            right: -11
        }
    }
});

const ChatLogDialog = observer(({ handleClose, classes, open, userAuditionId, isPublic }) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {
        if (open) {
            getData();
        }
    }, [open]);

    const getData = async () => {
        setLoading(true);
        const res = await loadCandidateMessages(userAuditionId, isPublic);
        console.log(res);
        if (res.success) {
            setData(res.data);
        }
        setLoading(false);
    };

    return (
        <Dialog
            open={open}
            maxWidth="md"
            onClose={handleClose}
            titleComponent="Chat Log"
            handleClose={handleClose}
        >
            {
                loading ? (
                    <CircularProgress
                        size={22}
                        className={classes.progress}
                    />
                ) : (
                    <div className="u-pdn--lx3 u-pdn--rx3">
                        {
                            data.map((el, idx) => (
                                <div key={idx} className="u-mrg--bx4">
                                    {
                                        el.sender === 'bot' && (
                                            <div className="u-dsp--f u-ai--start">
                                                <img className="u-mrg--rx5" src={KoalaIcon} alt="" />
                                                <div>
                                                    {el.name && <span className={classes.name}>{el.name}</span>}
                                                    <div className={clsx(classes.botMessage, classes.message)}>
                                                        {ReactHtmlParser(el.message)}
                                                        <img src={BotMessageIcon} alt="" />
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                    {
                                        el.sender === 'candidate' && (
                                            <div className="u-dsp--f u-ai--start u-jc--end">
                                                <div className={clsx(classes.candidateMessage, classes.message)}>
                                                    {ReactHtmlParser(el.message)}
                                                    <img src={CandidateMessageIcon} alt="" />
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            ))
                        }
                    </div>
                )
            }
        </Dialog>
    );
});

export default withStyles(styles)(ChatLogDialog);
